module.exports = __webpack_public_path__ + "img/logo.0a71367d.jpeg";